import { ChecklistItemServerStatus } from './../types/checklist_types';
import { ChecklistItem } from './../builders/checklist_item_builder';
import { ChecklistConfiguration } from './../config/checklist_configuration';
import { IDefineCommand, ICommand } from 'core-ts-types';

angular.module('capability-ng-checklist').factory(
  'udpateChecklistItemStatusServerCommand',
  (
    $http: ng.IHttpService,
    defineCommand: IDefineCommand,
    ngChecklistConfiguration: ChecklistConfiguration
  ): ICommand => {
    return defineCommand(
      'udpateChecklistItemStatusServerCommand',
      (deferred: ng.IDeferred<void>, item: ChecklistItem, newStatus: ChecklistItemServerStatus) => {
        $http({
          method: 'PATCH',
          url: `${ngChecklistConfiguration.capability.checklistUrl}event-chain/${item.id}/`,
          data: {
            status: newStatus
          }
        })
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            deferred.resolve();
          })
          .catch(deferred.reject);
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/lib/checklist/commands/update_checklist_item_status_server_command.ts